import { $PropertyType } from 'utility-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { State, ConfigState } from '../@types';

export type Props = {
  googleApiAccessToken: $PropertyType<ConfigState, 'googleApiAccessToken'>;
  apiBaseURL: $PropertyType<ConfigState, 'apiBaseURL'>;
  apiVersion: $PropertyType<ConfigState, 'apiVersion'>;
  bundleId: $PropertyType<ConfigState, 'bundleId'>;
  appleAppId: $PropertyType<ConfigState, 'appleAppId'>;
  xBrandId: $PropertyType<ConfigState, 'xBrandId'>;
  turnstileSiteKey: $PropertyType<ConfigState, 'turnstileSiteKey'>;
};

const withConfig: any = compose(
  connect(
    ({
      config: {
        googleApiAccessToken,
        apiBaseURL,
        apiVersion,
        bundleId,
        appleAppId,
        xBrandId,
        turnstileSiteKey,
      },
    }: State) => ({
      googleApiAccessToken,
      apiBaseURL,
      apiVersion,
      bundleId,
      appleAppId,
      xBrandId,
      turnstileSiteKey,
    })
  )
);
export default withConfig;
